@if (req(); as r) {
  <div class="dms-delete__backdrop" role="dialog" aria-modal="true" aria-labelledby="dms-delete-title" (click)="onBackdropClick($event)">
    <div class="dms-delete__panel" data-testid="dms-delete-dialog-panel">
      <div class="dms-delete__header">
        <div class="dms-delete__icon-wrap" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </div>
        <div>
          <h2 class="dms-delete__title" id="dms-delete-title">Dokument „{{ r.documentName }}" — was möchtest du tun?</h2>
          <p class="dms-delete__subtitle">Dieses Dokument ist mit folgenden Einträgen verknüpft:</p>
        </div>
      </div>

      <!-- Verknüpfte Objekte (konkrete Liste aus der Preview) -->
      @if (tree().length) {
        <ul class="dms-delete__tree" role="list" aria-label="Verknüpfte Objekte">
          @for (item of tree(); track $index) {
            <li class="dms-delete__tree-item">
              <span class="dms-delete__tree-dot" aria-hidden="true"></span>
              <span class="dms-delete__tree-label">{{ item.label }}</span>
            </li>
          }
        </ul>
      } @else {
        <p class="dms-delete__empty">{{ r.preview.summary || 'Keine Verknüpfungen' }}</p>
      }

      <div class="dms-delete__actions">
        <button type="button" class="dms-delete__btn dms-delete__btn--cancel" (click)="onCancel()" data-testid="dms-delete-dialog-cancel-btn">Abbrechen</button>

        @if (r.entityType !== null) {
          <button
            type="button"
            class="dms-delete__btn dms-delete__btn--unlink"
            [disabled]="r.isLastLink"
            [attr.title]="r.isLastLink ? 'Letzte Verknüpfung — nutze stattdessen &quot;Dokument löschen&quot;' : null"
            (click)="onUnlink()"
            data-testid="dms-delete-dialog-unlink-btn"
          >
            {{ unlinkLabel() }}
          </button>
          @if (r.isLastLink) {
            <p class="dms-delete__hint" data-testid="dms-delete-dialog-lastlink-hint">Letzte Verknüpfung — nutze stattdessen „Dokument löschen".</p>
          }
        }

        <button type="button" class="dms-delete__btn dms-delete__btn--delete" (click)="onDelete()" data-testid="dms-delete-dialog-delete-btn">
          Dokument inkl. aller Verknüpfungen löschen
        </button>
      </div>
    </div>
  </div>
}
